module.exports = __webpack_public_path__ + "img/paoduct3.277853dd.png";